/**
 * `utm_state` on a flight / mission binding (ENG-302). The old values
 * (active, ended, cancelled, rejected, …) are shown as the API spells them; the
 * two RTM on/off states need a sentence, since the raw word means nothing to an
 * operator.
 */
export type UtmTone = 'ok' | 'warn' | 'crit' | undefined;

/** RTM is off for this aircraft: the request is held and nothing went to RTM. */
export const UTM_HELD = 'held';
/** RTM has not confirmed an end/cancel; the OI may still be live there. */
export const UTM_END_FAILED = 'end_failed';

export function utmStateLabel(state: string | null | undefined): string | null {
  if (state == null || state === '') return null;
  if (state === UTM_HELD) return 'Held — RTM off';
  if (state === UTM_END_FAILED) return 'End unconfirmed — may still be live in RTM';
  return state;
}

export function utmStateTone(state: string | null | undefined): UtmTone {
  if (state === 'active') return 'ok';
  if (state === UTM_HELD) return 'warn';
  if (state === UTM_END_FAILED) return 'crit';
  return undefined;
}
